import { RouteObject } from 'react-router-dom';
import DayEndPage from './DayEndPage';

export const dayEndRoutes: RouteObject[] = [
    // Menu links use /admin/day-end (branch resolved from auth store inside DayEndPage)
    {
        path: '/admin/day-end',
        element: <DayEndPage />,
    },
    {
        path: '/admin/session-management/manage',
        element: <DayEndPage />,
    },
    // Keep parameterised route for direct deep-links (e.g. /admin/day-end/HQ001)
    {
        path: '/admin/day-end/:branch',
        element: <DayEndPage />,
    },
];
